import { useCallback } from "react";
import { Shell } from "../components/Shell";
import { MiniHero } from "../components/MiniHero";
import { PixelGallery } from "../components/PixelGallery";
import { LiveSection } from "../components/LiveSection";
import { OffersSection } from "../components/OffersSection";
import { CatalogSection } from "../components/CatalogSection";
import { goTo } from "../lib/scroll";
import { useRequestPrefill } from "../context/RequestPrefill";
import { checkoutUrl } from "../lib/pay";

// Home definitiva (ex Preview A): foto sfocate subito, diretta, poi piani e cataloghi. Il resto vive in pagine separate.
export default function Landing() {
  const { setPrefill } = useRequestPrefill();

  // Prezzo fisso -> cassa reale. Prezzo "da" / su misura -> modulo richiesta.
  const onRequest = useCallback((p) => {
    if (p?.kind) { window.__navigate?.(checkoutUrl(p)); return; }
    setPrefill({ ...p, nonce: Date.now() });
    setTimeout(() => goTo("richieste"), 60);
  }, [setPrefill]);

  return (
    <Shell testId="landing-page">
      <MiniHero />
      <PixelGallery onRequest={onRequest} />
      <LiveSection onRequest={onRequest} />
      <OffersSection onRequest={onRequest} />
      <CatalogSection onRequest={onRequest} />
    </Shell>
  );
}
